import { Page, Pagebar, PagebarTitle } from '@monorepo/base/src/components/page/page';
import { DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';
import { observer } from 'mobx-react';
import { FC } from 'react';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../../modules/stores';
import { ControlledTable } from '@monorepo/controlled/src/components/table-wrapper/table-wrapper';
import { useRoute } from '../../../modules/hooks/tools/use-route';
import { useWebappsCidHeaders } from '../../../modules/hooks/theaders/webapps-cid.headers';
import styles from './webapps-cids.module.scss';
import { useList } from '../../../modules/hooks/tools/use-list';
import { WebappsCidModel } from '../../../modules/models/webapps-cid.model';

const pageBarDebugProps = { dataAttrs: [new DataAttribute('id', 'webapps_cids_pagebar')] };

export const ToolsWebappsCids: FC = observer(() => {
	const { webappsCidStore } = useStores<IAdminxStore>();
	const { currentRouteWithoutSpecialChars } = useRoute();
	const { columns } = useWebappsCidHeaders();

	useList<WebappsCidModel>(webappsCidStore.listStore);

	return (
		<Page>
			<Pagebar debugProps={pageBarDebugProps}>
				<PagebarTitle>CIDs</PagebarTitle>
			</Pagebar>

			<div className={styles.tableWrapper}>
				<ControlledTable
					currentRoute={currentRouteWithoutSpecialChars}
					columns={columns}
					data={webappsCidStore.listStore.getList()}
					isLoading={webappsCidStore.listStore.getIsLoading()}
					removeColumnsPicker
				/>
			</div>
		</Page>
	);
});
